/**
 * Copyright © 2026 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import { createFarmlandsPROApi, type FarmlandsPROApi } from "@farmlands/farmlandspro-api";
import type { AxiosError } from "axios";

import { error as logError } from "../../util/log";

let getAccessToken: () => Promise<string> = async () => "";

export const setFarmlandsProApiGetAccessToken = (fn: () => Promise<string>): void => {
  getAccessToken = fn;
};

let accountNumber: string | undefined;

export const setFarmlandsProApiAccountNumber = (value: string): void => {
  accountNumber = value;
  if (farmlandsProApiInstance) {
    farmlandsProApiInstance.client.defaults.headers["X-Account-Number"] = value;
  }
};

export const isFarmlandsProApiAccountNumberApplied = (
  expectedAccountNumber: string | undefined
): boolean => !!expectedAccountNumber && expectedAccountNumber === accountNumber;

let farmlandsProApiInstance: FarmlandsPROApi | null = null;

const applyAccountNumber = (api: FarmlandsPROApi): void => {
  if (accountNumber) {
    api.client.defaults.headers["X-Account-Number"] = accountNumber;
  }
};

const buildInstance = (): FarmlandsPROApi => {
  const api = createFarmlandsPROApi({
    baseURL: process.env.REACT_APP_BASE_API_URL ?? "",
    enableAuth: true,
    getAccessToken: () => getAccessToken(),
    onError: (axiosError: AxiosError) => {
      logError(
        `farmlandsProApi ${axiosError.config?.method?.toUpperCase()} ${axiosError.config?.url} failed`,
        axiosError.message
      );
    },
  });

  applyAccountNumber(api);

  return api;
};

export const farmlandsProApi: FarmlandsPROApi = new Proxy({} as FarmlandsPROApi, {
  get(_, prop) {
    if (!farmlandsProApiInstance) {
      farmlandsProApiInstance = buildInstance();
    }

    return farmlandsProApiInstance[prop as keyof FarmlandsPROApi];
  },
});
